import { dialog } from "nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import { upsertUseCase } from "../../../usecases/object";
import InputFactory from "../../../components/InputFactory";
import {
  PASSWORD_TITLE,
  passwordInputProps,
  isStrongPassword,
} from "../../../components/InputFactory/passwordPolicy";

class DTRAttachementPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  confirmChangePass = async (data, pass) => {
    console.log("DTA: ", data);
    try {
      if (!isStrongPassword(pass)) {
        this.view.showError(PASSWORD_TITLE);
        return;
      }
      data.password = pass;
      await upsertUseCase().execute("users", data);
      dialog.close();
      this.view.showSuccess(`${data.username} Successfully Change Password`);
      this.view.refetchData();
    } catch (e) {
      console.error("USer page", e);
    }
  };

  // reset password
  handleResetPass(data) {
    let newPass = "";
    dialog.fire({
      html: (
        <>
          <div className="p-2">
            <h4>Reset Password Confirmation</h4>
            <hr />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.confirmChangePass(data, newPass);
              }}
            >
              <p style={{ fontSize: "20px" }}>
                <strong>User: {data.username}</strong> ?
              </p>
              <label>
                New Password<span className="text-danger">*</span>
              </label>
              <InputFactory
                type="Password"
                required
                {...passwordInputProps()}
                onChange={(value) => {
                  newPass = value;
                }}
              />
              <hr />
              <div className="mt-4 mb-4 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light fs-sm me-3"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  // onClick={this.handleSaveButton.bind(this)}
                  className="btn btn-primary fs-sm me-3"
                >
                  confirm
                </button>
              </div>
            </form>
          </div>
        </>
      ),
      footer: false,
    });
  }
}

export default DTRAttachementPagePresenter;
